import {EntityBase} from "../../shared/entity/EntityBase";
import dayjs from "dayjs";
import {toUnixTime} from "../../shared/utils/dayjsUtil";

const SHOP_PACKAGE_FIELDS = {
    seq: { type: (v) => parseInt(v) || 0, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    packageName: { defaultValue: '' },
    onOff: { defaultValue: 0 },
    begin: { type: toUnixTime, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: toUnixTime, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    packageTime: { type: Number, defaultValue: 0 },
    intervalValue: { type: Number, defaultValue: 0 },
    intervalUnit: { defaultValue: 'hour' },
    saleType: { type: Number, defaultValue: 0 },
    maxBuyCount: { type: Number, defaultValue: 0 },  // 0 = 기간 내 1회(기존 동작)
    coolTime: { type: Number, defaultValue: 0 },     // 재구매 쿨타임(분)
    memo: { defaultValue: '' },
    isPersonal: { type: Number, defaultValue: 0 },
};

export class ShopPackageEntity extends EntityBase {
    constructor(data = {}) {
        super(data, SHOP_PACKAGE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
            {condition: () => !this.begin || !this.end, message: '시작일/종료일 형식이 올바르지 않습니다.'},
            {condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.'},
            {condition: () => !(this.maxBuyCount >= 0) || !(this.coolTime >= 0), message: '구매 횟수/쿨타임은 0 이상이어야 합니다.'},
        ];
    }

    getIdentityKey() {
        return 'index';
    }
}